import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

export const ProjectDetailsContainer = styled.div`
  padding-top: 0.5rem;
`;

export const ProjectDetailsTitle = styled.h2`
  margin: 0 0 1.25rem;
  font-size: clamp(1.15rem, 2vw, 1.5rem);
  font-weight: 750;
  letter-spacing: -0.02em;
  background: linear-gradient(135deg, #f8fafc 0%, #c7d2fe 55%, #a5b4fc 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const ProjectDetailsContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  padding: 2rem 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1rem 0;
  }
`;

export const DetailItem = styled.div`
  background: linear-gradient(145deg, rgba(0, 0, 0, 0.7) 0%, rgba(30, 30, 50, 0.8) 100%);
  border-radius: 15px;
  padding: 1.5rem;
  border-left: 4px solid #007eee;
  position: relative;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(0, 126, 238, 0.1),
      transparent
    );
    transition: left 0.5s;
  }

  &:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 15px 30px rgba(0, 126, 238, 0.3);
    border-left-color: #00a2ff;

    &::before {
      left: 100%;
      animation: ${shimmer} 0.6s ease-in-out;
    }
  }

  @media (max-width: 768px) {
    padding: 1.2rem;
    border-radius: 12px;
    
    &:hover {
      transform: translateY(-2px) scale(1.01);
    }
  }
`;

export const DetailLabel = styled.span`
  display: block;
  color: #007eee;
  font-weight: 700;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background: linear-gradient(90deg, #007eee, #00a2ff);
    transition: width 0.3s ease;
  }

  ${DetailItem}:hover &::after {
    width: 100%;
  }

  @media (max-width: 768px) {
    font-size: 0.8rem;
    letter-spacing: 0.5px;
  }
`;

export const DetailValue = styled.span`
  display: block;
  color: white;
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 1.4;
  word-wrap: break-word;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`; 